/**
 * MASTER-DATA-FOUNDATION-000001 — Master Data hub (Settings → Master Data).
 * Warehouse Master live; other masters reserved architecture only.
 */
import { Link } from 'react-router-dom';
import { RESERVED_MASTER_MODULES } from '../api/warehouseMaster';

export function MasterDataHubPage() {
  return (
    <div className="min-h-dvh bg-[var(--bg,theme(colors.slate.50))] text-slate-900 dark:bg-slate-950 dark:text-slate-100">
      <div className="mx-auto max-w-5xl px-4 py-8 sm:px-6">
        <p className="text-xs font-medium uppercase tracking-wide text-slate-500 dark:text-slate-400">
          Settings · Master Data
        </p>
        <h1 className="mt-1 text-2xl font-semibold tracking-tight sm:text-3xl">Reference Master</h1>
        <p className="mt-2 max-w-2xl text-sm text-slate-600 dark:text-slate-400">
          Permanent source of reference for platform modules. Never invent geo or taxonomy — map only what is known.
        </p>

        <section className="mt-8" aria-labelledby="wh-heading">
          <h2 id="wh-heading" className="text-lg font-semibold">
            Live masters
          </h2>
          <Link
            to="/settings/master-data/warehouses"
            className="mt-4 flex min-h-11 cursor-pointer items-center justify-between gap-4 rounded-lg border border-slate-200 bg-white px-4 py-4 transition hover:border-slate-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600 dark:border-slate-700 dark:bg-slate-900 dark:hover:border-slate-500"
          >
            <div>
              <div className="font-medium">Warehouse Master</div>
              <p className="mt-0.5 text-sm text-slate-500 dark:text-slate-400">
                Amazon FC codes → name, city, state, region. Unknown codes stay Unknown until mapped.
              </p>
            </div>
            <span className="shrink-0 text-sm font-medium text-sky-700 dark:text-sky-400">Open →</span>
          </Link>
        </section>

        <section className="mt-10" aria-labelledby="res-heading">
          <h2 id="res-heading" className="text-lg font-semibold">
            Reserved (not this sprint)
          </h2>
          <ul className="mt-4 grid gap-2 sm:grid-cols-2">
            {RESERVED_MASTER_MODULES.map((m) => (
              <li
                key={m.id}
                className="rounded-lg border border-dashed border-slate-300 px-4 py-3 text-sm text-slate-500 dark:border-slate-600 dark:text-slate-400"
              >
                <span className="font-medium text-slate-700 dark:text-slate-300">{m.label}</span>
                <span className="ml-2 text-xs uppercase tracking-wide">reserved</span>
              </li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
}
